import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Layers, Sparkles, Wrench, Ruler, DoorOpen, Sofa, Shield, Grid3X3 } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const iconMap = {
  Layers,
  Sparkles,
  Wrench,
  Ruler,
  DoorOpen,
  Sofa,
  Shield,
  Grid3X3
};

const ServiceCard = ({ service, compact = false }) => {
  const IconComponent = iconMap[service.icon] || Layers;

  if (compact) {
    return (
      <Card className="group h-full bg-white hover:shadow-xl transition-all duration-300 border-slate-100 overflow-hidden">
        <CardContent className="p-6">
          <div className="w-14 h-14 bg-amber-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-amber-100 transition-colors">
            <IconComponent className="w-7 h-7 text-amber-600" />
          </div>
          <h3 className="text-lg font-semibold text-slate-800 mb-2 group-hover:text-amber-700 transition-colors">
            {service.title}
          </h3>
          <p className="text-slate-600 text-sm leading-relaxed">
            {service.shortDesc}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="group h-full bg-white hover:shadow-2xl transition-all duration-500 border-slate-100 overflow-hidden">
      <div className="relative h-56 overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          <div className="w-12 h-12 bg-white/95 rounded-xl flex items-center justify-center shadow-lg">
            <IconComponent className="w-6 h-6 text-amber-600" />
          </div>
        </div>
      </div>
      <CardContent className="p-6">
        <h3 className="text-xl font-semibold text-slate-800 mb-3 group-hover:text-amber-700 transition-colors">
          {service.title}
        </h3>
        <p className="text-slate-600 text-sm leading-relaxed mb-4">
          {service.shortDesc}
        </p>
        <Link
          to={`/servizi#${service.id}`}
          className="inline-flex items-center gap-2 text-amber-600 hover:text-amber-700 font-medium text-sm group/link"
        >
          Scopri di più
          <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
        </Link>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;
